import { CampaignRoutes } from './type'

const campaigns = `${CampaignRoutes.root}`
const campaignsAll = `${campaigns}/${CampaignRoutes.all}`

export const CampaignsPath = {
  root: campaigns,
  all: campaignsAll,
}
